// extracted by mini-css-extract-plugin
export default {"slider_container":"AutoPlay_slider_container__iMT5U","logo":"AutoPlay_logo__XKKHV","sliders_container":"AutoPlay_sliders_container__NlwiN"};